export default {
  validatePhone(phone) {
    var phoneRegex = /^(\+34)?[0-9]{3}((-|\/| )?[0-9]{2}){3}$/

    return phoneRegex.test(phone)
  },
  validateDNI(dni) {
    var numero, letNIF, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    dni = dni.toUpperCase();

    if (expresion_regular_dni.test(dni) === true) {
      numero = dni.substr(0, dni.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      letNIF = dni.substr(dni.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);
      if (letra != letNIF) {
        //alert('Dni erroneo, la letra del NIF no se corresponde');
        return false;
      } else {
        //alert('Dni correcto');
        return true;
      }
    } else {
      //alert('Dni erroneo, formato no válido');
      return false;
    }
  },
  isValidCif(cif) {
    if (!cif || cif.length !== 9) {
      return false;
    }

    var letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    var digits = cif.substr(1, cif.length - 2);
    var letter = cif.substr(0, 1);
    var control = cif.substr(cif.length - 1);
    var sum = 0;
    var i;
    var digit;

    if (!letter.match(/[ABCDEFGHJNPQRSUVW]/)) {
      return false;
    }

    for (i = 0; i < digits.length; ++i) {
      digit = parseInt(digits[i]);

      if (isNaN(digit)) {
        return false;
      }

      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) {
          digit = parseInt(digit / 10) + (digit % 10);
        }

        sum += digit;
      } else {
        sum += digit;
      }
    }

    sum %= 10;
    if (sum !== 0) {
      digit = 10 - sum;
    } else {
      digit = sum;
    }

    if (letter.match(/[ABEH]/)) {
      return String(digit) === control;
    }
    if (letter.match(/[NPQRSW]/)) {
      return letters[digit] === control;
    }

    return String(digit) === control || letters[digit] === control;
  },
  validateNif(nif) {
    return this.validateDNI(nif);
  },
  validateNifEmpresa(nif) {
    var nifRegex = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/
    return nifRegex.test(nif)
  },
  validateNifOrCif(nif) {
    return (this.isValidCif(nif) || this.validateDNI(nif));
  },
  validateMail(mail) {
    var mailRegex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return mailRegex.test(mail)
  },
  validatePostalCode(code, postalCode) {
    // var postalCodeRegex = /^[0-9]{5}$/
    var postalCodeRegex = /^(?:0?[1-9]|[1-4]\d|5[0-2])\d{3}$/
    return postalCode != null ? postalCode.startsWith(code) && postalCodeRegex.test(postalCode) : false
  },
  validateIbanControlDigit(controlDigit) {
    var controlDigitRegex = /^[0-9]{2}$/
    return controlDigitRegex.test(controlDigit)
  },
  validateIbanBankId(bankId) {
    var controlDigitRegex = /^[0-9]{4}$/
    return controlDigitRegex.test(bankId)
  },
  validateIbanAccountCode(accountCode) {
    var controlDigitRegex = /^[0-9]{2}$/
    return controlDigitRegex.test(accountCode)
  },
  validateIbanAccountNumber(accountNumber) {
    var controlDigitRegex = /^[0-9]{10}$/
    return controlDigitRegex.test(accountNumber)
  }
}